define([], function() {
    'use strict';
    return function noop() {

    };
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/js/util/noop.js
 ** module id = 19
 ** module chunks = 0
 **/